import React, { useEffect } from "react";
import Layout from "@/components/layout";
import Markdown from "@/components/markdown";
import Image from "@/components/image";
import { useDeviceDetect } from "hooks";
import styles from "../styles/dynamic.module.scss";
import WizardCard from "@/components/wizard-card";
import { pageEvent } from "@/lib/gtm";

const DynamicPage = ({ config }) => {
	useEffect(() => {
		pageEvent(config.slug);
	}, [config]);

	const { isSmallScreen } = useDeviceDetect();
	return (
		<Layout
			{...config}
			useSelfReferringCanonicalUrl={!config.canonicalUrl && config.slug}
			canonicalUrl={config.canonicalUrl}
		>
			<div className="container pb-5 px-xs pt-5">
				<div className={`row min-vh-100 ${styles.dynamicContainer}`}>
					{config.content.map((item, ix) => {
						let content = null;
						if (item.__component === "assets.image-set") {
							const image = isSmallScreen ? item.mobile : item.desktop;
							if (!image) {
								return null;
							}
							content = <Image src={image.url} alt={item.alt} width="100%" />;
						} else if (item.__component === "sections.rich-text") {
							content = <Markdown markdown={item.content} />;
						} else if (item.__component === "assets.wizard-card") {
							content = (
								<div style={{ marginTop: "25px" }}>
									<WizardCard
										title={item.title}
										mascotAlt={item.mascot?.alternativeText ?? ""}
										mascotUrl={item.mascot?.url ?? ""}
										diagnosisType={item.diagnosisType}
										visitType={item.visitType}
										readMoreText={item.readMoreText}
										readMoreUrl={item.readMoreUrl}
										symbolAlt={item.symbol.alternativeText}
										squareSymbolUrl={item.symbol.url}
										wideSymbolUrl={item.symbolMobile.url}
										text={item.text}
										wizardButtonText={item.wizardButtonText}
									/>
								</div>
							);
						} else {
							return null;
						}

						return (
							<div key={ix.toString()} className="col-sm-12">
								{content}
							</div>
						);
					})}
				</div>
			</div>
		</Layout>
	);
};

export default DynamicPage;
